import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';

function mapStateToProps (state) {
  const {
    locale: { locale, messages }
  } = state;
  return { locale, messages };
}

export default connect(mapStateToProps)(IntlProvider);
